import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { CONTACT } from "../config";

const sections = [
  {
    title: "Información que es recogida",
    body: [
      "Nuestro sitio web podrá recoger información personal por ejemplo: Nombre, información de contacto como su dirección de correo electrónica e información demográfica. Así mismo cuando sea necesario podrá ser requerida información específica para procesar algún pedido o realizar una entrega o facturación.",
    ],
  },
  {
    title: "Uso de la información recogida",
    body: [
      "Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios, de pedidos en caso que aplique, y mejorar nuestros productos y servicios. Es posible que sean enviados correos electrónicos periódicamente a través de nuestro sitio con ofertas especiales, nuevos productos y otra información publicitaria que consideremos relevante para usted o que pueda brindarle algún beneficio, estos correos electrónicos serán enviados a la dirección que usted proporcione y podrán ser cancelados en cualquier momento.",
      "Juan Pablo Cortes está altamente comprometido para cumplir con el compromiso de mantener su información segura. Usamos los sistemas más avanzados y los actualizamos constantemente para asegurarnos que no exista ningún acceso no autorizado.",
    ],
  },
  {
    title: "Cookies",
    body: [
      "Una cookie se refiere a un fichero que es enviado con la finalidad de solicitar permiso para almacenarse en su ordenador, al aceptar dicho fichero se crea y la cookie sirve entonces para tener información respecto al tráfico web, y también facilita las futuras visitas a una web recurrente. Otra función que tienen las cookies es que con ellas las web pueden reconocerte individualmente y por tanto brindarte el mejor servicio personalizado de su web.",
      "Nuestro sitio web emplea las cookies para poder identificar las páginas que son visitadas y su frecuencia. Esta información es empleada únicamente para análisis estadístico y después la información se elimina de forma permanente. Usted puede eliminar las cookies en cualquier momento desde su ordenador. Sin embargo las cookies ayudan a proporcionar un mejor servicio de los sitios web, estás no dan acceso a información de su ordenador ni de usted, a menos de que usted así lo quiera y la proporcione directamente. Usted puede aceptar o negar el uso de cookies, sin embargo la mayoría de navegadores aceptan cookies automáticamente pues sirve para tener un mejor servicio web. También usted puede cambiar la configuración de su ordenador para declinar las cookies. Si se declinan es posible que no pueda utilizar algunos de nuestros servicios.",
    ],
  },
  {
    title: "Enlaces a Terceros",
    body: [
      "Este sitio web pudiera contener enlaces a otros sitios que pudieran ser de su interés. Una vez que usted de clic en estos enlaces y abandone nuestra página, ya no tenemos control sobre al sitio al que es redirigido y por lo tanto no somos responsables de los términos o privacidad ni de la protección de sus datos en esos otros sitios terceros. Dichos sitios están sujetos a sus propias políticas de privacidad por lo cual es recomendable que los consulte para confirmar que usted está de acuerdo con estas.",
    ],
  },
  {
    title: "Control de su información personal",
    body: [
      "En cualquier momento usted puede restringir la recopilación o el uso de la información personal que es proporcionada a nuestro sitio web. Cada vez que se le solicite rellenar un formulario, como el de alta de usuario, puede marcar o desmarcar la opción de recibir información por correo electrónico. En caso de que haya marcado la opción de recibir nuestro boletín o publicidad usted puede cancelarla en cualquier momento.",
      "Esta compañía no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento, salvo que sea requerido por un juez con un orden judicial.",
      "Juan Pablo Cortes se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.",
    ],
  },
];

export default function AvisoPrivacidad() {
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[var(--bg)] relative">
      <div className="absolute top-0 right-0 w-[36rem] h-[36rem] noise-ring rounded-full pointer-events-none opacity-40" />
      <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <Link
          to="/"
          data-testid="privacy-back"
          className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors duration-200"
        >
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <p className="overline mt-10 mb-3">Legal</p>
        <h1 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl leading-[1.05]">
          Aviso de Privacidad
        </h1>

        <p className="mt-7 text-zinc-400 leading-relaxed">
          La presente <span className="text-white font-medium">Política de Privacidad</span> establece
          los términos en que <span className="text-white font-medium">Juan Pablo Cortés</span> usa y
          protege la información que es proporcionada por sus usuarios al momento de utilizar su sitio
          web. Esta compañía está comprometida con la seguridad de los datos de sus usuarios. Cuando le
          pedimos llenar los campos de información personal con la cual usted pueda ser identificado, lo
          hacemos asegurando que sólo se empleará de acuerdo con los términos de este documento. Sin
          embargo esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le
          recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de
          acuerdo con dichos cambios.
        </p>

        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <section key={s.title} data-testid="privacy-section">
              <h2 className="font-display font-semibold text-xl sm:text-2xl text-white">{s.title}</h2>
              <div className="mt-4 space-y-4">
                {s.body.map((p, i) => (
                  <p key={i} className="text-zinc-400 leading-relaxed">{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 text-sm text-zinc-500">
          ¿Dudas sobre el manejo de tus datos? Escríbenos a{" "}
          <a href={`mailto:${CONTACT.email}`} className="text-[var(--magenta)] hover:underline">
            {CONTACT.email}
          </a>
          .
        </div>
      </div>
    </div>
  );
}
